import axios from "axios";
import { getEnvVariable } from "@/api/axios";
import { AddressInterface, GeoCoordinatesInterface } from "@/api/Interfaces/MapInterface";
import { ErrorHandler } from "vue-router/types/router";

type errorHandling = (error: any) => any;

export default class MapService {
  static async getZipCode(apiUrl: any) {
    const { data } = await axios.get(apiUrl);

    if (data.cep || data.code) {
      return data;
    }

    return {};
  }

  static async getLocationByZipCode(zipCode: string): Promise<AddressInterface | boolean> {
    const apiUrl = [
      `https://viacep.com.br/ws/${zipCode}/json/`,
      `https://brasilapi.com.br/api/cep/v1/${zipCode}`,
      `https://cep.awesomeapi.com.br/json/${zipCode}`,
      // `https://ws.apicep.com/cep/${zipCode}.json`,
    ];

    const maxRandomRange = apiUrl.length - 1;
    let apiOptions = [...Array(apiUrl.length).keys()];
    let currentApiIndex = Math.floor(Math.random() * (maxRandomRange + 1));
    let formatedResponse: any = {};

    while (apiOptions.length > 0) {
      try {
        const currentApi = apiUrl[currentApiIndex];
        const responseLocation = await this.getZipCode(currentApi);

        formatedResponse = this.formatResponseByZipCodeApi(currentApiIndex, responseLocation);

        if (formatedResponse?.state && formatedResponse?.city) {
          return formatedResponse;
        }

      } catch (error) {
        console.warn(`Erro ao consultar API ${currentApiIndex}:`, error);
      }

      apiOptions = apiOptions.filter((i) => i !== currentApiIndex);
      if (apiOptions.length > 0) {
        currentApiIndex = apiOptions[Math.floor(Math.random() * apiOptions.length)];
      }
    }

    return false;
  }

  static formatResponseByZipCodeApi(apiIndex: number, responseData: any) {
    switch (apiIndex) {
      case 0: {
        // url: https://viacep.com.br/ws/${zipCode}/json/
        return {
          city: responseData.localidade,
          neighboorhood: responseData.bairro,
          postalCode: responseData.cep,
          state: responseData.uf,
          street: responseData.logradouro,
        };
      }
      case 1: {
        // url: https://brasilapi.com.br/api/cep/v1/${zipCode}
        return {
          city: responseData.city,
          neighboorhood: responseData.neighborhood,
          postalCode: responseData.code,
          state: responseData.state,
          street: responseData.street,
        };
      }
      case 2: {
        // url: https://cep.awesomeapi.com.br/json/${zipCode}
        return {
          city: responseData.city || "",
          neighboorhood: responseData.district || "",
          postalCode: responseData.cep || "",
          state: responseData.state || "",
          street: responseData.address || "",
        };
        // url:https://ws.apicep.com/cep/${zipCode}.json
        // return {
        //   city: responseData.city,
        //   neighboorhood: responseData.district,
        //   postalCode: responseData.code,
        //   state: responseData.state,
        //   street: responseData.address,
        // };
      }
      default:
        return {};
    }
  }

  static async getGeoCoordinatesByAddress(
    address: any,
    errorHandling?: errorHandling
  ): Promise<GeoCoordinatesInterface | ErrorHandler | void> {
    if (address.street || address.city) {
      const formattedAddress = `${address.street}, ${address.number ? address.number : 0}, ${address.city}, ${address.state}`;
      const azureMapsKey = await getEnvVariable("VUE_APP_AZURE_MAPS_KEY", 5);
      const url = `https://atlas.microsoft.com/search/address/json?` +
        `api-version=1.0&` +
        `subscription-key=${azureMapsKey}&` +
        `query=${encodeURIComponent(formattedAddress)}`;

      return axios
        .get(url)
        .then((response) => {
          if (response.data.results && response.data.results.length > 0) {
            const position = response.data.results[0].position;
            const geoCoordinates: GeoCoordinatesInterface = {
              latitude: position.lat,
              longitude: position.lon,
            };
            return geoCoordinates;
          } else {
            throw new Error("Nenhum resultado de geolocalização encontrado.");
          }
        })
        .catch((error) => {
          if (errorHandling) {
            errorHandling(error);
          } else {
            this.errorDefaultMessage(error);
          }
        });
    }

    if (errorHandling) {
      errorHandling(address);
    } else {
      this.errorDefaultMessage(address);
    }
  }

  static async getAddressByGeoCoordinates(
    latitude: string | number,
    longitude: string | number,
    errorHandling?: errorHandling
  ): Promise<AddressInterface | ErrorHandler | void> {
    try {
      const azureMapsKey = await getEnvVariable("VUE_APP_AZURE_MAPS_KEY", 5);
      const url = `https://atlas.microsoft.com/search/address/reverse/json?` +
        `api-version=1.0&` +
        `subscription-key=${azureMapsKey}&` +
        `query=${latitude},${longitude}`;
      const response = await axios.get(url);

      if (response.data.addresses && response.data.addresses.length > 0) {
        const addr = response.data.addresses[0].address;
        const address: AddressInterface = {
          city: addr.municipality || "",
          neighboorhood: addr.municipalitySubdivision || "",
          postalCode: addr.postalCode || "",
          state: addr.countrySubdivision || "",
          street: addr.streetName || "",
        };
        return address;
      } else {
        throw new Error("Nenhum endereço encontrado para essas coordenadas.");
      }
    } catch (error) {
      if (errorHandling) {
        errorHandling(error);
      } else {
        this.errorDefaultMessage(error);
      }
    }
  }

  static errorDefaultMessage(error: any): void {
    console.error("%c Pending error handling => ", "font-weight: bold", error);
    throw new Error("%c Pending error handling => " + error.message);
  }
}
